export class ShipmentEventEquipment {
  equipmentType: string;
  equipmentNumber: string;

  constructor(opts: ShipmentEventEquipment) {
    this.equipmentType = opts.equipmentType;
    this.equipmentNumber = opts.equipmentNumber;
  }
}
